import axios from "../utils/axios";

// 🏢 Get Cart by User
export const getCartByUser = async (userId) => {
  const response = await axios.get("/api/Cart/GetCartByUser", {
    params: { userId },
  });
  //console.log(response);
  return response.data;
};

// 🏢 Add to cart
export const addToCart = async (cartItem) => {
  const response = await axios.post("/api/Cart/AddToCart", cartItem);
  //console.log(response);
  return response.data;
};

// 🏢 Update cart qty
export const updateCart = async (cartItem) => {
  const response = await axios.post("/api/Cart/UpdateCart", cartItem);
  //console.log(response);
  return response.data;
};

// remove from cart
export const removeFromCart = async (cartId) => {
  const response = await axios.post("/api/Cart/RemoveFromCart", null ,{
    params: { cartId },
  });
  //console.log(response);
  return response.data;
}